import { create } from "zustand";
import { persist } from "zustand/middleware";

type Shared3dDiceSettingState = {
  [userId: number]: boolean;
  getIsShared3dDiceSettingEnabled: (userId: number) => boolean;
  setIsShared3dDiceSettingEnabled: (userId: number) => void;
};

export const useShared3dDiceSettingStore = create<Shared3dDiceSettingState>()(
  persist(
    (set) => ({
      getIsShared3dDiceSettingEnabled: (userId: number): boolean =>
        useShared3dDiceSettingStore.getState()[userId],
      setIsShared3dDiceSettingEnabled: (userId: number): void => {
        set(() => ({
          ...useShared3dDiceSettingStore.getState(),
          [userId]:
            useShared3dDiceSettingStore.getState()[userId] === undefined
              ? true
              : !useShared3dDiceSettingStore.getState()[userId],
        }));
      },
    }),
    {
      name: "isShared3dDiceEnabled",
    },
  ),
);
